import {css} from "@panda/css";

import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {DesktopSidebar} from "./DesktopSidebar";
import {MobileHeader} from "./MobileHeader";

export const Navigation = () => {
    const {isMobile} = useUserDevice();

    return (
        <div data-testid={KM_COMMON_TEST_IDS.MAIN_NAVIGATION_MENU}>
            {isMobile ? (
                <div className={navigationMobileStyle}>
                    <MobileHeader />
                </div>
            ) : (
                <DesktopSidebar />
            )}
        </div>
    );
};

const navigationMobileStyle = css({
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: "var(--zIndex-navigationChrome)",
    backgroundColor: "var(--colors-white)"
});
import {css} from "@panda/css";

import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {DesktopSidebar} from "./DesktopSidebar";
import {MobileHeader} from "./MobileHeader";

export const Navigation = () => {
    const {isMobile} = useUserDevice();

    return (
        <div data-testid={KM_COMMON_TEST_IDS.MAIN_NAVIGATION_MENU}>
            {isMobile ? (
                <div className={navigationMobileStyle}>
                    <MobileHeader />
                </div>
            ) : (
                <DesktopSidebar />
            )}
        </div>
    );
};

const navigationMobileStyle = css({
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: "var(--zIndex-navigationChrome)",
    backgroundColor: "var(--colors-white)"
});
